/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import './../App.css'
import './accounts.css'
import { useNavigate } from "react-router-dom";
import { buildHttpGet } from "./utils/backendInterface.js";
import { buildTable } from "./utils/table.js";
import { isDev } from "./utils/helper.js";

const Account = () => {
    const navigate = useNavigate();
    let _isDev = isDev();
    let pathArray = window.location.pathname.split('/');
    let companyId;
    let groupId;

    if (pathArray.length > 2) {
        companyId = pathArray[2];
    }
    if (pathArray.length > 4) {   // because URL is /companies/{companyId}/groups/{groupId}/accounts
        groupId = pathArray[4];
    }

    useEffect(() => {
        if (!companyId || !groupId) return;

        // Fetch accounts for this group
        buildHttpGet(`/companies/${companyId}/groups/${groupId}/accounts`, (data) => {
            buildTable("accountsTable", data, (row) => {
                const accountId = row.id;
                navigate(`/companies/${companyId}/groups/${groupId}/accounts/${accountId}`);
            });
        });
    }, [companyId, groupId, navigate]);

    return (
        <div className="container mt-3">
            <h2>Accounts</h2>
            <div id="accountsTable"></div>
        </div>
    );
};

export default Account;
